import { render, staticRenderFns } from "./RmcDiscountTile.vue?vue&type=template&id=c517b296&scoped=true&"
import script from "./RmcDiscountTile.vue?vue&type=script&lang=js&"
export * from "./RmcDiscountTile.vue?vue&type=script&lang=js&"
import style0 from "./RmcDiscountTile.vue?vue&type=style&index=0&id=c517b296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c517b296",
  null
  
)

export default component.exports